var enableBackgroundVideo;

enableBackgroundVideo = function() {
  var introBg, setContent, videoElement, videoHTML, videoID, videoSource;
  if (($('.bg[data-video]').length)) {
    introBg = $('.bg');
    videoSource = $.map(introBg.data('video').split(','), function(val) {
      var splitName, videoFormat;
      splitName = val.split('.');
      videoFormat = splitName[splitName.length - 1];
      if (videoFormat === "ogv") {
        return '<source src="' + val + '" type="video/ogg">';
      } else {
        return '<source src="' + val + '" type="video/mp4">';
      }
    });
    videoID = 'frontpage-video';
    videoHTML = '<video id="' + videoID + '" autoplay="true" loop="true">' + videoSource + '</video>';
    videoElement = $('#' + videoID);
    setContent = function() {
      var bgState, ref;
      bgState = (ref = !Modernizr.video || Detectizr.os.name === 'ios' || Detectizr.os.name === 'android') != null ? ref : {
        "image": "video"
      };
      if (bgState !== introBg.data('status')) {
        if (Modernizr.video && Detectizr.os.name !== 'ios' && Detectizr.os.name !== 'android') {
          if (!videoElement.length) {
            introBg.html(videoHTML);
            videoElement = $('#' + videoID);
          }
          videoElement.on('canplaythrough', function() {
            introBg.removeClass('loading');
            introBg.siblings('.slideshow').remove();
            return videoElement.get(0).play();
          }).on('ended', function() {
            return videoElement.get(0).play();
          });
        } else {
          introBg.removeClass('loading');
          if (videoElement.length) {
            videoElement.get(0).pause();
          }
        }
        return introBg.attr('data-status', bgState);
      }
    };
    return setContent();
  }
};

$(function() {
  return enableBackgroundVideo();
});

// ---
// generated by coffee-script 1.9.2